<template>
    <section class="quiz-finish-page">
        <div class="quiz-finish-container">
            <h1 class="font-20 font-weight-bold text-center">{{ quizTitle }} - {{ userName }}</h1>
            <div class="quiz-finish-blocks">
                <div class="quiz-finish-block" v-for="(question, index) in questions">
                    <div v-if="(question.type === 'text' || question.type === 'textarea' || question.type === 'custom-file')">
                        <h6 class="answer-title">{{ index + 1 }}. {{ question.title }}</h6>
                        <div class="mb-4" v-if="question.file_type && question.file">
                            <a v-if="question.file_type === 'image'" :href="question.file" target="_blank" rel="noreferrer noopener">
                                <img :src="question.file" alt="question image">
                            </a>
                            <video v-else-if="question.file_type === 'video'" :src="question.file"
                                   controls="controls" width="100%">
                                <source id='mp4' :src="question.file" type='video/mp4'/>
                                <source id='webm' :src="question.file" type='video/webm'/>
                            </video>
                            <custom-iframe
                                v-else :url="question.file"
                                width="100%"
                                height="300px"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></custom-iframe>
                        </div>
                        <div class="quiz-finish-teacher">
                            <div class="quiz-finish-teacher-left">

                                <div v-if="userAnswers[question.id] && userAnswers[question.id].answers && userAnswers[question.id].answers.length">
                                    <div v-if="question.type === 'custom-file'">
                                        <p v-for="file in userAnswers[question.id].answers">
                                            <a target="_blank" :href="file.file"
                                               :download="true" class="d-block">
                                                {{ file.original_name }}
                                            </a>
                                        </p>
                                    </div>

                                    <p v-else>
                                        {{ userAnswers[question.id].answers }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!(question.type === 'text' || question.type === 'textarea' || question.type === 'custom-file')">
                        <h6 class="answer-title">
                            {{ index + 1 }}. {{ question.title }}
                        </h6>

                        <div  class="mb-4" v-if="question.file_type && question.file">
                            <a v-if="question.file_type === 'image'" :href="question.file" target="_blank" rel="noreferrer noopener">
                                <img :src="question.file" alt="question image">
                            </a>
                            <video v-else-if="question.file_type === 'video'" :src="question.file"
                                   controls="controls" width="100%">
                                <source id='mp4' :src="question.file" type='video/mp4'/>
                                <source id='webm' :src="question.file" type='video/webm'/>
                            </video>
                            <custom-iframe
                                v-else :url="question.file"
                                width="100%"
                                height="300px"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen></custom-iframe>
                        </div>
                    </div>
                    <div
                        v-if="!(question.type === 'text' || question.type === 'textarea' || question.type === 'custom-file')"
                        v-for="(answer, answerIndex) in question.answers"
                        :class="{
                                'answer-text': question.type !== 'file',
                                'answer-img': question.type === 'file',
                                'correct-answer' : answerIsChecked(question.id, answer.id),
                        }"
                    >
                        <div v-if="question.type !== 'file'">
                            <p>
                                {{ answerIndex + 1 }}. {{ answer.title }}
                            </p>
                        </div>

                        <img v-else :src="answer.file" alt="answer file" width="341" height="167">
                    </div>
                </div>
            </div>
            <Download :report-id="id"/>
        </div>
    </section>
</template>

<script>
import {mapMutations} from "vuex";
import Download from "../../../../../TenantForms/Resources/assets/js/components/Download";
import CustomIframe from "../../../../../TenantDashboardForms/Resources/assets/js/components/CustomIframe.vue";

export default {
    name: "FormReport",
    props: ['id'],
    components: {Download, CustomIframe},
    methods: {
        ...mapMutations(['fetchQuizReport']),

        answerIsChecked(questionId, answerId) {
            let answer = null;
            if (this.userAnswers && this.userAnswers[questionId] && this.userAnswers[questionId].answers) {
                for (const answerItem of this.userAnswers[questionId].answers) {
                    if (answerId === answerItem.id) {
                        answer = answerItem;
                        break;
                    }
                }
            }

            return !!answer;
        },
    },
    computed: {
        questions() {
            let questions = this.$store.state.activeQuiz?.questions;
            if (questions) {
                for (let question of questions) {
                    if (question.has_other) {
                        let otherText = this.trans('other') + ': ';
                        if (this.userAnswers && this.userAnswers[question.id] && this.userAnswers[question.id].answers) {

                            const otherAnswer = this.userAnswers[question.id].answers.filter(answer => answer.type === 'other');
                            if (otherAnswer.length) {
                                otherText += otherAnswer[0].title ?? '';
                            }
                        }

                        question.answers.push({
                            type: 'other',
                            title: otherText,
                        });
                    }
                }

                return questions;
            }

            return [];
        },

        quizTitle() {
            if (this.$store.state.activeQuiz?.title) {
                return this.$store.state.activeQuiz?.title
            }

            return '';
        },

      userName() {
        if (this.$store.state.userName) {
          return this.$store.state.userName;
        }

        return this.trans('An unknown user');
      },

      userAnswers() {
          if (this.$store.state?.userAnswers) {
              return this.$store.state?.userAnswers
          }

          return []
      },
    },
}
</script>
